import React from "react"
import { Helmet } from "react-helmet"

export default () => {
    return(
        <Helmet>
            <link href="https://fonts.googleapis.com/css?family=Poppins:400,900&display=swap" rel="stylesheet"/>
        </Helmet>
    )
}
